import produce from 'immer';

import { SET_PLAN_DETAILS } from '../constants';

export default function rootReducer(baseState = {}, action) {
  return produce(baseState, (state) => {
    switch (action.type) {
      case SET_PLAN_DETAILS:
        return { ...state, planDetails: action.payload };
      case 'STORE_PRIMUS_RESPONSE':
        if (action.payload && action.payload._handler && action.payload._handler !== 'ping_pong') {
          state[action.payload._handler] = action.payload;
          break;
        } else {
          state.set_response = action.payload;
          break;
        }
      default:
        break;
    }
  });
}
